import { useTranslation } from "react-i18next";
import { Flex, Switch, Text } from "@chakra-ui/react";

function LanguageSwitch() {
  const { i18n, t } = useTranslation();
  const language = i18n.language; // "es" o "en"

  const toggleLanguage = () => {
    const newLang = language === "es" ? "en" : "es";
    i18n.changeLanguage(newLang);
    localStorage.setItem("lang", newLang);
  };

  return (
    <Flex align="center" gap={3}>
      <Text
        color={language === "es" ? "#d7b363" : "white"}
        fontWeight="bold"
        fontFamily="Inter"
      >
        {t("language.spanish")}
      </Text>

      <Switch
        isChecked={language === "en"}
        onChange={toggleLanguage}
        sx={{

          "span.chakra-switch__track": {
            border: "1px solid #d7b363",
            bg: "transparent",
            height: "28px",
            width: "56px",
          },

          "input:checked + span.chakra-switch__track": {
            bg: "rgba(174, 130, 69, 0.2)",
            borderColor: "#AE8245",
          },

          "span.chakra-switch__thumb": {
            bg: "#AE8245",
            margin: "3px",
            width: "20px",
            height: "20px",
          },
        }}
      />

      <Text
        color={language === "en" ? "#d7b363" : "white"}
        fontWeight="bold"
        fontFamily="Inter"
      >
        {t("language.english")}
      </Text>
    </Flex>
  );
}

export default LanguageSwitch;
